export interface ElementGoodRefDTO {
  code: string;
  label: string;
}

export interface PriceDTO {
  amount: string;
  currency: string;
  taxIncl: boolean;
}

export interface InsuredGoodDto {
  brand: string;
  family: ElementGoodRefDTO;
  model: string;
  nature: ElementGoodRefDTO;
  purchaseDate: string;
  purchasePrice: PriceDTO;
  purchaseStore: ElementGoodRefDTO;
  serialNumber: string;
  type: ElementGoodRefDTO;
}

export const initialState = {
  sellingPointList: [],
  insuredElementList: [],
  insuredGood: {} as InsuredGoodDto
};

export type InsuredElementState = Readonly<typeof initialState>;
export type InsuredGoodState = Readonly<typeof initialState.insuredGood>;
